export default __webpack_public_path__ + "chating-kids.png?4ecb10315b4547fa79f7c454f4e5ecc3";